import Header from "src/common/layouts/header/Header";
import React, { useEffect, useState } from "react";
import { indexWrapCss, widthCss } from "./css/MyPage.style"
import { useNavigate } from "react-router-dom";
import Footer from "../footer/Footer";
import MypageTab from "./MypageTab";
import { useIsMobile } from "../../../hooks/useIsMobile";
import ProfileSection from "./components/ProfileSection";
import BookCardList from "./components/BookCardList";
import PostCardList from "./components/PostCardList";
import AuthorList from "./components/AuthorList";
import { getAuthorInfo } from "../../../api/index";

// Author Note Components
import AuthorNoteList from "../../../domain/author/components/AuthorNoteList";
import AuthorNoteDetail from "../../../domain/author/components/AuthorNoteDetail";
import AuthorNoteWrite from "../../../domain/author/components/AuthorNoteWrite";
import Alert from "../modal/Alert";

interface Profile {
    type: string;
    authorInfo: AuthorInfo;
    userInfo: UserInfo;
}

interface AuthorInfo {
    followerCount: number;
    keyword1: string;
    nickname: string;
    profilePhoto: string;
    totalLikeCount: string;
}

interface UserInfo {
    followerCount: number;
    keyword1: string;
    nickname: string;
    profilePhoto: string;
    totalLikeCount: string;
}

interface Book {
    bookId: number;
    bookTitle: string;
    coverImage: string;
    authorName?: string;
}

interface MypageBook {
    bookId: number;
    bookTitle: string;
    coverImage: string;
    authorName?: string;
}

interface Postcard {
    postCardId: number;
    postCardPhoto: string;
    postCardDescription?: string;
    createdAt?: string;
    authorEmail?: string;
    authorName?: string;
    authorProfilePhoto?: string;
    instagramLink?: string;
    xlink?: string;
    naverLink?: string;
    brunchLink?: string;
    likeCount?: number;
    like?: boolean;
    testStatus?: boolean;
}

interface MypagePostCard {
    postCardId: number;
    postCardPhoto: string;
    postCardDescription?: string;
    createdAt?: string;
    authorEmail?: string;
    authorName?: string;
    authorProfilePhoto?: string;
    instagramLink?: string;
    xlink?: string;
    naverLink?: string;
    brunchLink?: string;
    likeCount?: number;
    like?: boolean;
    testStatus?: boolean;
}

interface Author {
    id: number;
    name: string;
    bio: string;
}

interface MypageProps {
    profileList: Profile;
    bookData: Book[];
    postcardData: Postcard[];
    authorData: Author[];
    mypageBookData: MypageBook[];
    mypagePostCardData: MypagePostCard[]
    bookPage: number;
    postcardPage: number;
    handlePageChange: (type: 'book' | 'postcard' | 'author' | 'mypageBook' | 'mypagePostcard', newPage: number) => void;
}

interface CtaCardProps {
    isMobile: boolean;
    highlight: string;
    prefix: string;
    suffix: string;
    description: string;
    buttonLabel: string;
    onClick: () => void;
}

const CtaCard: React.FC<CtaCardProps> = ({ isMobile, highlight, prefix, suffix, description, buttonLabel, onClick }) => (
    <div className="w-full flex flex-col items-center justify-center gap-0 bg-[#F9FDFA] border-[1px] border-[#e1f7eb] rounded-2xl py-10 px-8">
        <div className="w-12 h-12 rounded-full bg-[#e1f7eb] flex items-center justify-center text-[#19cf7a] text-2xl font-bold mb-4">+</div>
        <p className={`text-[#333] text-center font-medium mb-2 ${isMobile ? 'text-[15px]' : 'text-[18px]'}`}>
            {prefix} <span className="text-[#19cf7a] font-bold">{highlight}</span>{suffix}
        </p>
        <p className={`text-[#888] text-center mb-6 ${isMobile ? 'text-[12px]' : 'text-[14px]'}`}>{description}</p>
        <button
            onClick={onClick}
            className="bg-[#19cf7a] text-white font-bold rounded-full px-10 py-3 shadow-[0px_4px_6px_rgba(25,207,122,0.2)] hover:bg-[#00b368] transition-colors text-[15px]"
        >
            {buttonLabel}
        </button>
    </div>
);

const NewMyPage = ({ profileList, bookData, postcardData, authorData, mypageBookData, mypagePostCardData, bookPage, handlePageChange }: MypageProps) => {

    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };
    const [tabs, setTabs] = useState<string[]>([]);
    const [subTab, setSubTab] = useState<string[]>([]);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [activeSubTab, setActiveSubTab] = useState(0);

    // Activity Tab State (Level 3 for "활동")
    const [activityIndex, setActivityIndex] = useState(0);

    const [authors, setAuthors] = useState<any>([]); // 작가 목록 상태
    const [users, setUsers] = useState<any>([]); // 일반 유저

    const [bookList, setBookList] = useState<any>([]); // 등록 작품 리스트
    const [postCardList, setPostCardList] = useState<any>([]); // 등록 엽서 리스트
    const [likeBookList, setLikeBookList] = useState<any>([]); // 보관함 > 좋아하는 작품 리스트
    const [likePostCardList, setLikePostCardList] = useState<any>([]); //보관함 > 좋아하는 엽서 리스트
    const [likeAuthorList, setLikeAuthorList] = useState<any>([]);

    const [authorType, setAuthorType] = useState<string>(); // 작가 목록 상태 추가

    // Author Note States
    const [noteView, setNoteView] = useState<'list' | 'detail' | 'write' | 'edit'>('list');
    const [selectedNoteId, setSelectedNoteId] = useState<string>('');
    const [editingNoteData, setEditingNoteData] = useState<any>(null);

    const [showAlert, setShowAlert] = useState<false | "login" | "already" | "waiting" | "deactivated" | "deactivated_book" | "deactivated_goods" | "deactivated_note">(false);
    const [ctaSlide, setCtaSlide] = useState(0);

    useEffect(() => {
        if (authorType !== 'author') return;
        const t = setInterval(() => setCtaSlide(i => (i + 1) % 2), 3500);
        return () => clearInterval(t);
    }, [authorType]);

    const handleAuthorClick = () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (!currentStatus || currentStatus === "null" || currentStatus === "undefined") {
            setShowAlert("login");
        } else {
            const status = currentStatus.toLowerCase();
            if (status === "author" || status === "active") {
                setShowAlert("already");
            } else if (status === "hold") {
                setShowAlert("deactivated");
            } else if (status === "pending" || status === "w") {
                setShowAlert("waiting");
            } else {
                navigate("/addAuthor");
            }
        }
    };

    const handleBookRegisterClick = () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (currentStatus && currentStatus.toLowerCase() === "hold") {
            setShowAlert("deactivated_book");
        } else {
            navigate('/addBook');
        }
    };

    const handleGoodsRegisterClick = () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (currentStatus && currentStatus.toLowerCase() === "hold") {
            setShowAlert("deactivated_goods");
        } else {
            navigate('/addGoods');
        }
    };

    let email = localStorage.getItem("email")

    const formatTitle = (title: string) => {
        if (!title) return '';
        const maxChars = 20;
        const firstLine = title.slice(0, 10);
        const secondLine = title.slice(10, 20);
        const needsEllipsis = title.length > maxChars;
        return (
            <>
                {firstLine}<br />
                {secondLine}{needsEllipsis && '...'}
            </>
        );
    };

    const handleProfileEdit = () => {
        navigate("/profileEdit", {
            state: { email },
        });
    };

    const moveToBook = (bookId: number) => {
        navigate(`/book/bookdetails/${bookId}`);
    };

    const moveToAuthor = async (author: any) => {
        if (author.authorId) {
            navigate(`/author/authordetails/${author.authorId}`, {
                state: { authorEmail: author.authorEmail }
            });
        } else if (author.authorEmail) {
            try {
                const authorInfo = await getAuthorInfo({ authorEmail: author.authorEmail });
                if (authorInfo && authorInfo.authorId) {
                    navigate(`/author/authordetails/${authorInfo.authorId}`, {
                        state: { authorEmail: author.authorEmail }
                    });
                } else {
                    navigate(`/author/authordetails/${author.authorName.replace(/\s+/g, '')}`, {
                        state: { authorEmail: author.authorEmail }
                    });
                }
            } catch (error) {
                console.error("Failed to fetch authorInfo in NewMyPage:", error);
                navigate(`/author/authordetails/${author.authorName.replace(/\s+/g, '')}`, {
                    state: { authorEmail: author.authorEmail }
                });
            }
        }
    };

    // Note Handlers
    const handleNoteDetail = (noteId: string) => {
        setSelectedNoteId(noteId);
        setNoteView('detail');
    };
    const handleNoteWrite = () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (currentStatus && currentStatus.toLowerCase() === "hold") {
            setShowAlert("deactivated_note");
        } else {
            setEditingNoteData(null);
            setNoteView('write');
        }
    };
    const handleNoteEdit = (data: any) => {
        setEditingNoteData(data);
        setNoteView('edit');
    };
    const handleBackToList = () => {
        setNoteView('list');
        setSelectedNoteId('');
        setEditingNoteData(null);
    };

    const isReady = !!authorType && bookList && likeBookList && likeAuthorList;

    useEffect(() => {
        if (!profileList || !profileList.type) return;

        const type = profileList.type;
        setAuthorType(type);

        setBookList(mypageBookData)
        setPostCardList(mypagePostCardData)

        setLikeBookList(bookData)
        setLikePostCardList(postcardData)
        setLikeAuthorList(authorData)

        if (type === "author") {
            setTabs(["작가 노트", "보관함"]);
            setAuthors(profileList.authorInfo);
        } else {
            setTabs(["좋아하는 작품", "좋아하는 엽서", "팔로우한 작가"]);
            setUsers(profileList.userInfo);
        }
    }, [isMobile, profileList, bookData, postcardData, authorData, mypageBookData, mypagePostCardData]);

    useEffect(() => {
        if (authorType === "author") {
            setSubTab(["등록 작품", "엽서북", "활동"]);
        }
    }, [authorType]);

    // Activity View Component (Level 3)
    const ActivityView = () => {
        const bookCount = Array.isArray(likeBookList?.content) ? likeBookList.totalElements : 0;
        const postcardCount = Array.isArray(likePostCardList?.content) ? likePostCardList.totalElements : 0;
        const authorCount = Array.isArray(likeAuthorList?.content) ? likeAuthorList.totalElements : 0;

        const activityTabs = [
            `좋아하는 작품 (${bookCount})`,
            `좋아하는 엽서 (${postcardCount})`,
            `팔로우한 작가 (${authorCount})`
        ];

        return (
            <div className="w-full">
                <div className="flex gap-10 md:gap-5 mb-8 md:mb-5 flex-wrap">
                    {activityTabs.map((tab, idx) => (
                        <button
                            key={idx}
                            onClick={() => setActivityIndex(idx)}
                            className={`text-[18px] md:text-[15px] transition-colors ${
                                activityIndex === idx
                                    ? 'font-semibold text-[#19cf7a]'
                                    : 'text-[#888] font-normal'
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {activityIndex === 0 && (
                    <BookCardList
                        books={likeBookList?.content}
                        moveToBook={moveToBook}
                        formatTitle={formatTitle}
                        totalPages={likeBookList?.totalPages}
                        currentPage={bookPage}
                        onPageChange={(page) => handlePageChange('book', page)}
                        emptyMessage="좋아하는 작품이 없습니다."
                    />
                )}
                {activityIndex === 1 && (
                    <PostCardList
                        postCards={likePostCardList?.content}
                        totalPages={likePostCardList?.totalPages}
                        currentPage={bookPage}
                        onPageChange={(page) => handlePageChange('postcard', page)}
                        emptyMessage="좋아하는 엽서가 없습니다."
                    />
                )}
                {activityIndex === 2 && (
                    <AuthorList
                        authorCards={likeAuthorList?.content}
                        moveToAuthor={moveToAuthor}
                        formatTitle={formatTitle}
                        totalPages={likeAuthorList?.totalPages}
                        currentPage={bookPage}
                        onPageChange={(page) => handlePageChange('author', page)}
                        emptyMessage="팔로우한 작가가 없습니다."
                    />
                )}
            </div>
        );
    };

    const tabContents = [
        authorType === 'author' ? (
            <div className="w-full">
                {/* 목록 뷰: 회색 컨테이너 (Figma 5574-2912) */}
                {noteView === 'list' && (
                    <div className="bg-[#f5f5f5] border border-[#dbdbdb] rounded-[8px] overflow-hidden">
                        <AuthorNoteList
                            authorEmail={email || ''}
                            isOwner={true}
                            onViewDetail={handleNoteDetail}
                            onWrite={handleNoteWrite}
                            variant="mypage"
                        />
                    </div>
                )}

                {/* 상세 뷰: AuthorNoteDetail이 자체적으로 회색 배경 + 흰 글 카드 + 댓글 분리 처리 */}
                {noteView === 'detail' && (
                    <AuthorNoteDetail
                        noteId={selectedNoteId}
                        isOwner={true}
                        onBack={handleBackToList}
                        onEdit={handleNoteEdit}
                        variant="mypage"
                    />
                )}

                {/* 작성/수정 뷰: AuthorNoteWrite 자체가 회색(#f5f5f5) 배경 */}
                {(noteView === 'write' || noteView === 'edit') && (
                    <AuthorNoteWrite
                        authorEmail={email || ''}
                        initialData={editingNoteData}
                        onCancel={handleBackToList}
                        onComplete={handleBackToList}
                    />
                )}
            </div>
        ) : (
            <BookCardList
                books={likeBookList?.content}
                moveToBook={moveToBook}
                formatTitle={formatTitle}
                totalPages={likeBookList?.totalPages}
                currentPage={bookPage}
                onPageChange={(page) => handlePageChange('book', page)}
                emptyMessage="좋아하는 작품이 없습니다."
            />
        ),

        authorType === 'author' ? (
            <></>
        ) : (
            <PostCardList
                postCards={likePostCardList?.content}
                totalPages={likePostCardList?.totalPages}
                currentPage={bookPage}
                onPageChange={(page) => handlePageChange('postcard', page)}
                emptyMessage="좋아하는 엽서가 없습니다."
            />
        ),

        authorType !== 'author' ? (
            <AuthorList
                authorCards={likeAuthorList?.content}
                moveToAuthor={moveToAuthor}
                formatTitle={formatTitle}
                totalPages={likeAuthorList?.totalPages}
                currentPage={bookPage}
                onPageChange={(page) => handlePageChange('author', page)}
                emptyMessage="팔로우한 작가가 없습니다."
            />
        ) : null
    ];

    const subTabContents = [
        <div className="w-full h-full min-w-0">
            <BookCardList
                books={bookList?.content}
                moveToBook={moveToBook}
                formatTitle={formatTitle}
                totalPages={bookList?.totalPages}
                currentPage={bookPage}
                onPageChange={(page) => handlePageChange('book', page)}
                emptyMessage="등록된 작품이 없습니다."
            />
        </div>,
        <div className="w-full h-full min-w-0">
            <PostCardList
                postCards={postCardList?.content}
                totalPages={postCardList?.totalPages}
                currentPage={bookPage}
                onPageChange={(page) => handlePageChange('postcard', page)}
                emptyMessage="등록된 엽서가 없습니다."
            />
        </div>,
        <div className="w-full h-full min-w-0">
            <ActivityView />
        </div>
    ];


    return (
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag=""
            />

            {/* 프로필 영역 — 그라디언트 배경 */}
            <div style={{ background: 'linear-gradient(180deg, #e8f8f0 0%, #fafafa 100%)' }} className="w-full">
                <div className="max-w-[1200px] w-full mx-auto py-[60px] md:py-[36px] px-[15px]">
                    {authorType === "author" ? (
                        <ProfileSection isAuthor={true} profile={authors} onEdit={handleProfileEdit} />
                    ) : (
                        <ProfileSection isAuthor={false} profile={users} onEdit={handleProfileEdit} />
                    )}
                </div>
            </div>

            {/* 탭 + CTA 영역 — 흰 배경 */}
            <div className="w-full bg-[#fafafa]">
                <div className="max-w-[1200px] w-full mx-auto py-[40px] md:py-[24px] px-[15px] pb-[60px] flex flex-col gap-[60px]">
                    {/* 탭 섹션 */}
                    <div className="flex flex-col">
                        {isReady && (
                            <MypageTab
                                tabs={tabs}
                                subTab={subTab}
                                tabContents={tabContents}
                                subTabContents={subTabContents}
                                selectedTabIndex={selectedTabIndex}
                                onTabChange={(index) => setSelectedTabIndex(index)}
                                activeSubTab={activeSubTab}
                                onSubTabChange={(index) => setActiveSubTab(index)}
                            />
                        )}
                    </div>

                    {/* CTA 섹션 */}
                    {authorType === 'author' && (() => {
                        const isNoteTab = tabs[selectedTabIndex] === '작가 노트';
                        const isStorageTab = tabs[selectedTabIndex] === '보관함';
                        const isBookSubTab = isStorageTab && subTab[activeSubTab] === '등록 작품';
                        const isPostcardSubTab = isStorageTab && subTab[activeSubTab] === '엽서북';

                        if (isNoteTab) {
                            return (
                                <div className="w-full mt-12 md:mt-8">
                                    <div className="relative overflow-hidden">
                                        <div
                                            className="flex transition-transform duration-500 ease-in-out"
                                            style={{ transform: `translateX(-${ctaSlide * 100}%)` }}
                                        >
                                            <div className="w-full flex-shrink-0">
                                                <CtaCard
                                                    isMobile={isMobile}
                                                    prefix="작가님의"
                                                    highlight="작품"
                                                    suffix="을 추가해 보세요."
                                                    description="다양한 작품을 등록해 독자들에게 알려주세요!"
                                                    buttonLabel="작품 등록하기"
                                                    onClick={handleBookRegisterClick}
                                                />
                                            </div>
                                            <div className="w-full flex-shrink-0">
                                                <CtaCard
                                                    isMobile={isMobile}
                                                    prefix="작품과 관련한"
                                                    highlight="엽서"
                                                    suffix="를 추가해 보세요."
                                                    description="엽서북 수정도 이곳에서 자유롭게 할 수 있어요."
                                                    buttonLabel="새 엽서 추가하기"
                                                    onClick={handleGoodsRegisterClick}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex justify-center gap-2 mt-3">
                                            {[0, 1].map(i => (
                                                <button
                                                    key={i}
                                                    onClick={() => setCtaSlide(i)}
                                                    className={`w-2 h-2 rounded-full transition-colors ${ctaSlide === i ? 'bg-[#19cf7a]' : 'bg-[#ccc]'}`}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        if (isBookSubTab) {
                            return (
                                <div className="w-full mt-12 md:mt-8">
                                    <CtaCard
                                        isMobile={isMobile}
                                        prefix="작가님의"
                                        highlight="작품"
                                        suffix="을 추가해 보세요."
                                        description="다양한 작품을 등록해 독자들에게 알려주세요!"
                                        buttonLabel="작품 등록하기"
                                        onClick={handleBookRegisterClick}
                                    />
                                </div>
                            );
                        }
                        if (isPostcardSubTab) {
                            return (
                                <div className="w-full mt-12 md:mt-8">
                                    <CtaCard
                                        isMobile={isMobile}
                                        prefix="작품과 관련한"
                                        highlight="엽서"
                                        suffix="를 추가해 보세요."
                                        description="엽서북 수정도 이곳에서 자유롭게 할 수 있어요."
                                        buttonLabel="새 엽서 추가하기"
                                        onClick={handleGoodsRegisterClick}
                                    />
                                </div>
                            );
                        }
                        return null;
                    })()}

                    {authorType !== 'author' && (
                        <div className="w-full mt-12 md:mt-8">
                            <CtaCard
                                isMobile={isMobile}
                                prefix="출간하신 작품이 있다면"
                                highlight="작가 등록"
                                suffix="을 신청해 보세요."
                                description="심사를 통해 북밋에서 작가로 활동하실 수 있습니다."
                                buttonLabel="작가 등록 신청하기"
                                onClick={handleAuthorClick}
                            />
                        </div>
                    )}
                </div>
            </div>

            <Footer />

            {showAlert && (
                <Alert
                    title={showAlert === "login" ? "로그인이 필요해요" : "알림"}
                    message={
                        showAlert === "login"
                            ? "작가 등록을 신청하려면\n로그인이 필요합니다."
                            : showAlert === "already"
                            ? "이미 작가로 등록되어있어요!\n작가님의 다양한 작품 활동 소식을 많이 알려주세요 :)"
                            : showAlert === "waiting"
                            ? "이미 작가 등록 신청을 해주셨어요!\n운영진이 꼼꼼하게 검토하고 빠르게 안내해 드릴게요."
                            : showAlert === "deactivated"
                            ? "이미 작가로 등록되어있습니다."
                            : showAlert === "deactivated_book"
                            ? "현재 계정 이용이 제한된 상태입니다.\n운영 정책 위반으로 인해\n새로운 작품 등록 기능이 제한되었습니다.\n기존 게시글은 수정 후 안내 메일에 따라 재검토 요청이 가능합니다."
                            : showAlert === "deactivated_goods"
                            ? "현재 계정 이용이 제한된 상태입니다.\n운영 정책 위반으로 인해\n새로운 엽서 등록 기능이 제한되었습니다.\n기존 게시글은 수정 후 안내 메일에 따라 재검토 요청이 가능합니다."
                            : showAlert === "deactivated_note"
                            ? "현재 계정 이용이 제한된 상태입니다.\n운영 정책 위반으로 인해\n새로운 작가노트 등록 기능이 제한되었습니다.\n기존 게시글은 수정 후 안내 메일에 따라 재검토 요청이 가능합니다."
                            : ""
                    }
                    onClose={() => setShowAlert(false)}
                    showLoginOnConfirm={showAlert === "login"}
                />
            )}
        </div>
    )
}

export default NewMyPage;
